
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kb8hZ", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $eb0b43ccb27274c6$export$6503ec6e8aabbaf; }, function (v) { return $eb0b43ccb27274c6$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $eb0b43ccb27274c6$export$f7ad0328861e2f03; }, function (v) { return $eb0b43ccb27274c6$export$f7ad0328861e2f03 = v; });
var $eb0b43ccb27274c6$export$6503ec6e8aabbaf;
var $eb0b43ccb27274c6$export$f7ad0328861e2f03;
"use strict";
var $eb0b43ccb27274c6$var$mapping = new Map();
function $eb0b43ccb27274c6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$eb0b43ccb27274c6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $eb0b43ccb27274c6$var$resolve(id) {
    var resolved = $eb0b43ccb27274c6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$eb0b43ccb27274c6$export$6503ec6e8aabbaf = $eb0b43ccb27274c6$var$register;
$eb0b43ccb27274c6$export$f7ad0328861e2f03 = $eb0b43ccb27274c6$var$resolve;

});

parcelRegister("dwTKp", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $9d9981d69fbe6f4e$export$bdfd709ae4826697; }, function (v) { return $9d9981d69fbe6f4e$export$bdfd709ae4826697 = v; });
var $9d9981d69fbe6f4e$export$bdfd709ae4826697;
var $9d9981d69fbe6f4e$export$c9e73fbda7da57b6;
var $9d9981d69fbe6f4e$export$5a759dc7a1cfb72a;
"use strict";
var $9d9981d69fbe6f4e$var$bundleURL = {};
function $9d9981d69fbe6f4e$var$getBundleURLCached(id) {
    var value = $9d9981d69fbe6f4e$var$bundleURL[id];
    if (!value) {
        value = $9d9981d69fbe6f4e$var$getBundleURL();
        $9d9981d69fbe6f4e$var$bundleURL[id] = value;
    }
    return value;
}
function $9d9981d69fbe6f4e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $9d9981d69fbe6f4e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $9d9981d69fbe6f4e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $9d9981d69fbe6f4e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$9d9981d69fbe6f4e$export$bdfd709ae4826697 = $9d9981d69fbe6f4e$var$getBundleURLCached;
$9d9981d69fbe6f4e$export$c9e73fbda7da57b6 = $9d9981d69fbe6f4e$var$getBaseURL;
$9d9981d69fbe6f4e$export$5a759dc7a1cfb72a = $9d9981d69fbe6f4e$var$getOrigin;

});

var $3500eaf2af2d38cc$exports = {};


(parcelRequire("kb8hZ")).register((parcelRequire("dwTKp")).getBundleURL("lrLBb"), JSON.parse('["lrLBb","index.dde3fbd1.js","6OT74","de.35ab5fdb.js","2MWxt","es.0006f75c.js","3NN9W","fi.514a3c6b.js","i8WN1","fr.56e8a786.js","MMtuR","hu.02d096c3.js","j1Skh","id.7550c31e.js","hUIiR","ja.fb0d47dc.js","6SS5P","jv.a7092e42.js","klZAl","ko.cb7c2088.js","5xEoy","lv.05912199.js","fCBVN","nl.3b1f6891.js","3Cac3","pt-BR.a9d8541d.js","i3Nr5","ru.5f9d24ff.js","8ZRjr","su.9ebf25c5.js","bAwoY","sv.9304afc1.js","eiNJp","zh-CN.69d5a812.js","b1997","zh-TW.cff3bfc2.js","lSnO6","cancel.5edb67d5.svg","9Ua7l","check.42e17e77.svg","jD5OT","remove-layer.4e9b2b7d.svg","6J4df","brush-pressure.f4437531.svg","1q6SN","copy.4adadd0c.svg","c5Vx2","tool-picker.d0e69c3a.svg","igQQI","angle.f0b557ac.svg","jWp7Y","tool-zoom-in.d413f042.svg","epSIs","tool-zoom-out.299f4d1f.svg","8SBIg","viewport-reset.25476ab5.svg","d4Fgh","tool-hand.e7fc81b9.svg","fCZWp","edit-pencil.d7636d97.svg","9AkGX","edit-crop.16c534dd.svg","9hJLF","add-layer.ce1078bb.svg","lsJmT","duplicate-layer.3314e3c7.svg","bCMgi","merge-layers.19da79a6.svg","f86To","rename-layer.7c31d4f4.svg","lGYSP","caret-down.68d4cd16.svg","947pR","cursor-rotate.4dea8425.png","dqrIv","klecks-logo.2dcce02e.png","d6QhY","new-image.2d692480.svg","dN2ab","import.7a68c844.svg","aCqxE","export.2deb9ff8.svg","kSkGO","share.454898d1.svg","5XFBH","help.208e9032.svg","fmKrp","tool-paint.f73a8943.svg","hNxdd","tool-fill.3358320a.svg","4z4n1","tool-gradient.64486254.svg","5cR4b","tool-text.1cbd0325.svg","fOiHV","tool-shape.3de78c3f.svg","k2ipY","tool-select.bd971ee9.svg","ifxHh","tool-undo.9138898d.svg","5tRvX","edit-rotate.fd0e572a.svg","5chvZ","ui-collapse.2b5dfc6a.svg","cIo5j","align-left.4876a845.svg","fPucg","align-center.6f56d4bd.svg","4gdnS","align-right.1521d61c.svg","g34bk","typo-italic.7ab32910.svg","gfiav","typo-bold.5c790c89.svg","ialpb","Caveat-Regular.2fe80bbd.woff2","4YP0p","ClimateCrisis-Regular-VariableFont_YEAR.3ad02523.woff2","f9bZe","CorrectionBrush.a69973aa.woff2","dnR06","DancingScript-Regular.ef2fe647.woff2","lVw6N","Diabolik-Regular-VF.f4eeb79e.woff2","a0LKB","FreckleFace-Regular.05946539.woff2","eDCEO","Gloock-Regular.60f8f765.woff2","6nihP","Pacha.08c8457a.woff2","4rqd5","GochiHand-Regular.c45792b0.woff2","isxTc","PassionOne-Bold.9e08b0dc.woff2","9lp1S","PixeloidSans.bc292131.woff2","2yKB9","PlaypenSans-Thin.314b29a4.woff2","jJcCY","Quicksand-Light.1f0c44a2.woff2","1JYDa","Silkscreen-Regular.cef2b4cb.woff2","kVDlu","Tehroc-Regular.4540047b.woff2","caTXQ","YUNGA-Display.30c04a15.woff2","3ZTO3","edit-brightness-contrast.8430cb26.svg","96L1k","edit-curves.bbdb97b2.svg","fTbcm","edit-flip.00fd2c6b.svg","aIiTM","edit-hue-saturation.6e36cf05.svg","1U0O5","edit-invert.f5d05ba3.png","9niY9","edit-perspective.e23100db.svg","lk691","edit-resize.56391e2b.svg","eAynE","edit-tilt-shift.f8ae88b3.png","aUN7k","edit-to-alpha.f7a2065a.svg","5gWAz","edit-transform.c8795430.svg","d4p3L","edit-triangle-blur.d2c20f1d.png","kCVxO","edit-unsharp-mask.f1520547.png","bsH1l","edit-grid.e900ce7b.svg","RyImw","edit-noise.51bd751c.svg","EmeAk","edit-pattern.1a06e094.svg","7Rt4W","edit-vanish-point.fc5858e4.svg","dyycB","edit-distort.bdb643f2.svg","c2I3J","brush-pen.49a7b91e.svg","4zb4G","brush-blend.3706e8a1.svg","hcN4k","brush-sketchy.4c477c01.png","eDS4X","brush-pixel.673f3e4c.svg","7d2iV","brush-eraser.a9e10dce.svg","gRbY1","brush-smudge.45852bcd.svg","b1APB","brush-chemy.a5a188f6.svg","btdNZ","upload.5289e924.svg","ei2p7","loading.7ff8a2ac.gif","4tKUq","dist.8c48c278.js","isxCL","bitbof-logo.bc5e3ed5.svg","bsWXz","ui-swap-lr.7f474f51.svg","hn23i","licenses.7e27b050.js","af9Ft","font-licenses.857d957c.js","2ZMks","constrain.62f04e45.svg","bqfce","tab-settings.980aa34c.svg","aoHlj","tab-layers.c8a104e7.svg","1una9","tab-edit.b0f2915c.svg","3vbht","cursor-picker.dc155349.png","3J8Nz","cursor-fill.999c4916.png","ctTCZ","cursor-text.582bc0db.png","5WbMB","cursor-zoom-ew.9ecaf1c2.png","d1a78","select-mode-select.a497171d.svg","99VRR","select-mode-move.3778aa02.svg","2his1","select-default.59c89a67.svg","2ayjI","select-union.89b92ea7.svg","1rQR3","select-subtract.8960756d.svg","hBUxz","select-shape-rect.4ee8affe.svg","dYtoZ","select-shape-ellipse.2cdd0c2d.svg","4V8ev","select-shape-lasso.91ac9c84.svg","g3XkL","select-shape-poly.8eed0bea.svg"]'));


//# sourceMappingURL=index.runtime.a45ff6d5.js.map
